import { FC } from 'react'
import GroupCoursesPage from 'pages/protected/GroupCoursesPage'

const GroupCourses: FC = () => {
  return (
      <GroupCoursesPage showButtons />
  )
}
export default GroupCourses